import React, {useEffect, useMemo, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import Styles from './index.module.scss'
import NFTModal from "@/components/NFTModal";
import ActivityRules from "../components/ActivityRules";
import Service from "../service"
import {hideLoading, showLoading} from "@/components/loading";
import {Toast} from "antd-mobile";
import JsBridgeNew from "@/utils/jsbridgeNew";
import {objectToQueryParams} from "@/utils/publicFun";
import qs from "query-string";
import { copyText} from "@/utils/publicFun"
import NumberScroll from '@/components/NumberScroll';

/**
 * @description 茅台二期
 * @return {/culturalExchange_maotaisecond/home}
 */
const Btns = [
  { title: '规则', key: 1 }, { title: '实名', key: 2 },
]
const Home = () => {
  const pageDom = useRef(null);
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({});
  const [data, setData] = useState({});
  const [hasPermission, setHasPermission] = useState(false)
  // const [shiwuThing, setShiwuThing] = useState({})
  const { nftNo } = qs.parse(window.location.search);
  const [pageType, setPageType] = useState(0)//页面类型 1优先购 2特权购 3公开购
  const [currentScore, setCurrentScore] = useState(0) // 当前分值
  const [showScoreModal, setShowScoreModal] = useState(false) // 显示分值表弹窗
  const [showClaimSuccessModal, setShowClaimSuccessModal] = useState(false) // 显示领取成功弹窗
  const [claimedReward, setClaimedReward] = useState(null) // 领取成功的奖励信息
  const [rewards, setRewards] = useState([
    { id: 1, threshold: 2000, name: '天主教堂', claimed: false, canClaim: true ,status:0, image: require('@/assets/img/culturalExchange_mazu/tzjt@2x.png')},
    { id: 2, threshold: 10000, name: '商船会馆', claimed: true, canClaim: false ,status:0, image: require('@/assets/img/culturalExchange_mazu/schg@2x.png')},
    { id: 3, threshold: 75000, name: '董家渡', claimed: false, canClaim: false ,status:0, image: require('@/assets/img/culturalExchange_mazu/djd@2x.png')},
  ]) // 奖励列表  status:0未领取 1已领取 2可领取 threshold:分值
  const [rewardList, setRewardList] = useState([]) // 奖励列表
  const [rewardImage, setRewardImage] = useState('') // 奖励图片

  

  useEffect(() => {
    (()=>{
      getData(true);
      onDidFocus();
      // getData2()
      // setShowClaimSuccessModal(true);
    })()

  }, []);
//   const getData2 = async () => {
//     try {
//         showLoading()
//         const res = await Service.getGoodsDetail({collectionId: Service.collectionId})
//         hideLoading();
//         if (res.code !== '000000') throw res.msg;
//         if (res.data && res.data.info) {
//             setDetailData(res.data.info)
//         }
//     } catch (error) {
//         Toast.show(error);
//     }
  
// }

  const onDidFocus = () => {
    window.JsBridge.addListener().then(() => {
      getData(true)
      onDidFocus();
    });
  }
  const getData = async (loading = false) => {
    // const res2 = await Service.getGoodsData({},nftNo);
    try {
      if (loading) showLoading();
      if (loading) {
        const ruleres = await Service.getActivityRules();//解决没有token的问题
        const userInfoRes = await Service.getUserCertificateStatus();
        const accessRes = await Service.purchasePermissions();
        setUserInfo(userInfoRes);
        // setHasPermission(accessRes.data?.isPermission);
        // console.log(accessRes.data, accessRes.data.isPermission);
        // const res2 = await Service.getGoodsData({},nftNo);
        // if(res2?.data?.length > 0){
        //   const shiwu = res2.data.find(item => item?.goodsType === 3)
        //   console.log('shiwu===>', shiwu)
        //   setShiwuThing(shiwu)
        // }
      }
      const res = await Service.getInitData();
      if (loading) hideLoading();
      if (res.code !== '000000') throw res.msg;
      setData(res.data);
      setHasPermission(res.data?.isPermission)
      setPageType(parseInt(res.data?.flag) || 0)
      setCurrentScore(res.data?.point || 0)
      setRewardList(res.data?.rewardList || [])
      
    } catch (error) {
      hideLoading();
      Toast.show(error);

    }
  }

  // 从 rewardList 获取刻度值
  const thresholds = useMemo(() => {
    const level1 = rewardList.find(item => parseInt(item.level) === 1);
    const level2 = rewardList.find(item => parseInt(item.level) === 2);
    const level3 = rewardList.find(item => parseInt(item.level) === 3);
    return {
      level1: level1?.score || 2000,
      level2: level2?.score || 10000,
      level3: level3?.score || 75000
    };
  }, [rewardList]);

  // 同步 rewardList 的数据到 rewards
  useEffect(() => {
    if (rewardList && rewardList.length > 0) {
      setRewards(prevRewards => {
        return prevRewards.map(reward => {
          const matchedReward = rewardList.find(item => parseInt(item.level) === reward.id);
          if (matchedReward) {
            return {
              ...reward,
              status: matchedReward.status,
              threshold: matchedReward.score
            };
          }
          return reward;
        });
      });
    }
  }, [rewardList]);

  const onBack = () => {
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.back();
    } else {
      navigate(-1);
    }
  }
  const toMyCollection = () => {
    const url = `/myCollection?code=26`
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.replace("CustomWeb", { uri: `${window.location.origin}${url}` });
    } else {
      navigate(url, { replace: true });
    }
  }

  // 计算进度条百分比
  // 刻度位置：level1在10.42%，level2在50%，level3在89.58%（对齐下方图片）
  const calculateProgress = () => {
    const { level1, level2, level3 } = thresholds;
    if (currentScore < level1) {
      // 0-level1 对应 0%-10.42%
      return (currentScore / level1) * 10.42;
    } else if (currentScore < level2) {
      // level1-level2 对应 10.42%-50%
      return 10.42 + ((currentScore - level1) / (level2 - level1)) * (50 - 10.42);
    } else if (currentScore < level3) {
      // level2-level3 对应 50%-89.58%
      return 50 + ((currentScore - level2) / (level3 - level2)) * (89.58 - 50);
    } else {
      // >= level3 对应 100%
      return 100;
    }
  }

  // 领取奖励
  const handleClaimReward = async (rewardId) => {
    const reward = rewards.find(r => r.id === rewardId);
    if (!reward) {
      return;
    }
    // 只有 status === 0（待领取/可领取）时才能领取
    if (reward.status !== 0) {
      return;
    }
    try {
      // 调用接口领取奖励
      const res = await Service.receiveReward(rewardId);
      if (res.code !== '000000') throw res.msg;
      // 领取成功，显示弹窗
      setClaimedReward(reward);
      setShowClaimSuccessModal(true);
      const claimCollectList = res.data.claimCollectList;
      if(claimCollectList.length > 0){
        setRewardImage(claimCollectList[0].nftImage);
      }
      setRewards(rewards.map(r => 
        r.id === rewardId ? { ...r, status: 1 } : r
      ));
    } catch (error) {
      Toast.show(error || '领取失败');
    }
  }

  // 判断按钮状态
  // 接口返回 status: 0=待领取(可领取) 1=已领取 2=不可领取
  const getButtonState = (reward) => {
    if (reward.status === 1) {
      return 'claimed'; // 已领取
    } else if (reward.status === 0) {
      return 'canClaim'; // 待领取（可领取）
    } else {
      return 'disabled'; // 不可领取（status === 2）
    }
  }

  // 提示信息
  const tipsMessage = useMemo(() => {
    let msg = undefined;
    const { systemTime, startTime, endTime } = data;
    const currentT = new Date(systemTime?.replace(/-/g, "/")).getTime();
    const startT = new Date(startTime?.replace(/-/g, "/")).getTime();
    const endT = new Date(endTime?.replace(/-/g, "/")).getTime();
    if (!startTime || !endTime) {
      msg = "接口异常";
    } else if (currentT < startT) {
      msg = "活动未开始";
    } else if (currentT > endT) {
      msg = "活动已结束";
    }

    return msg;
  }, [data]);

  // 将数字转换为固定8位字符串，不足位数前面补0
  const formatPointPool = (value, length = 8) => {
    if (value === null || value === undefined || value === '') {
      return '0'.repeat(length);
    }
    const numValue = typeof value === 'string' ? parseInt(value, 10) : value;
    if (isNaN(numValue)) {
      return '0'.repeat(length);
    }
    return String(numValue).padStart(length, '0');
  };

  const buyHandle = () => {
    if(!hasPermission||(data?.allowNum ===0 && (pageType ===1 || pageType ===2))){
      return;
    }
    // const bynum = pageType === 1 ? (data?.ordNum || 0) : pageType === 2?(data?.rareNum || 0):0;
    // if(bynum === 0){
    //   Toast.show("超过购买数量");
    //   return;
    // }
    if (tipsMessage) {
      Toast.show(tipsMessage);
      return;
    }
    if (!userInfo?.ID) {
      Toast.show("请先实名认证");
      return;
    }
    const uri = `/ape/saleDetail?collectionId=${Service.collectionId}&code=${Service.activityCode}`;
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.push("CustomWeb", {
        uri: `${window.location.origin}${uri}`,
      });
    } else {
      navigate(uri);
    }
    
  }
  const onRightBtnClick = (item) => {
    if (item.key === 1) {
      const ModalInstance = NFTModal.show({
        content: <ActivityRules onClose={() => ModalInstance?.close()} />,
        getContainer: pageDom.current,
      });
    } else if (item.key === 2) {
      window.JsBridge.navigate('Verify');
    }
  }

   //立即领取 ，跳转G-member订单页面
   const handleToOrder = async (type) => {
    //type 1 优先购 2 全套漫画
    // Toast.show(data?.canNum);
    if(!data?.badgeNum) {
      Toast.show('暂无权益可领');
      return
    }
    const userInfo = await JsBridgeNew.getCurrentUserInfo();
      const param = objectToQueryParams({
        idf: 'exchangeCultural_gold',
        activityCode: Service.activityCode,
        req: data?.defaultGoods?.id,
        name: data?.defaultGoods?.goodsName,
        imgUrl: data?.defaultGoods?.imgUrl,
        productId:data?.defaultGoods?.goodsId,
        isChangeName:0,
        clientId: userInfo?.clientId,
        skUId: data?.defaultGoods?.goodsId,
        prizeImgUrl: data?.defaultGoods?.imgUrl,
        prizeName: data?.defaultGoods?.goodsName,
        nftNo: nftNo,
        remark: 1,
        needShowCount:data?.badgeNum,
      });
      window.JsBridge.push('CustomWeb', { uri:`${process.env.REACT_APP_GKT_LINK}/front/guapp/activityOrder?${param}`});
      onDidFocus();
  }
   //立即领取 ，跳转G-member订单页面
   const handleToOrder2 = async () => {
    const param = objectToQueryParams({
      id: data?.badgeRecord?.id,
      phone: data?.badgeRecord?.phone,
      prizeImgUrl: data?.badgeRecord?.productImgUrl,
      prizeName: data?.badgeRecord?.productName,
      prizeType: data?.badgeRecord?.productType,
      skuId: data?.defaultGoods?.goodsId,
      createTime: data?.badgeRecord?.createTime,
      consigneeName: data?.badgeRecord?.consigneeName,
      consigneeNumber: data?.badgeRecord?.consigneeNumber,
      province: data?.badgeRecord?.province,
      city: data?.badgeRecord?.city,
      area: data?.badgeRecord?.area,
      street: data?.badgeRecord?.street,
      address: data?.badgeRecord?.address,
      deliverStatus:data?.badgeRecord?.deliverStatus,
      deliverGoods:data?.badgeRecord?.deliverGoods||0,
      logCo:data?.badgeRecord?.logCo||"",
      trackNo:data?.badgeRecord?.trackNo||"",
      shipDate:data?.badgeRecord?.shipDate||"",
      orderId:data?.badgeRecord?.orderId||"",
      needShowCount:data?.badgeRecord?.desc,
    });
    window.JsBridge.push('CustomWeb', { uri: `${process.env.REACT_APP_GKT_LINK}/front/activities/lottery/orderDetail?${param}`});
      onDidFocus();
  }
  return (
    <div className={Styles.culturalExchangeHome} ref={pageDom}>
       <div className={Styles.topCard}>

      </div>
      <div className={Styles.back} onClick={onBack}></div>
      <div className={Styles.right_btns}>
        {
          Btns.map((btn, i) => {
            if (btn.key === 2 && userInfo?.ID) return null;
            return (
              <div key={i} className={Styles.rightBtn} onClick={() => onRightBtnClick(btn)}>{btn.title}</div>
            )
          })
        }
      </div>
      <div className={Styles.hintBtnBox}>
          <div className={Styles.hintBtn1}>
            <img src={require(pageType === 1 ? '@/assets/img/culturalExchange_mazu/hint1.png' : pageType===2?'@/assets/img/culturalExchange_mazu/hint2.png':pageType===3?'@/assets/img/culturalExchange_mazu/hint3.png':'@/assets/img/culturalExchange_mazu/hint4.png')} alt="hint1" />
          </div>
      </div>
      <div className={Styles.buyBtn} style={{ filter: hasPermission&&(data?.allowNum >0 || pageType===3) ? '' : 'grayscale(1)'}} onClick={buyHandle} disabled={hasPermission&&(data?.allowNum >0 || pageType===3)?false:true}>
        {/* <button disabled={!hasPermission} onClick={buyHandle}>立即购买</button> */}
      </div>
      {/* <button className={Styles.myCollectionsBtn} onClick={toMyGuards}>我的藏品{">"}</button> */}
      {data?.allowNum && <div className={Styles.textCount}>最多可购买{data?.allowNum || 0}个</div>}
      {/* <div className={Styles.textCount}>剩余可购买数量：{pageType === 1 ? (data?.ordNum || 0) : pageType === 2?(data?.rareNum || 0):0}</div> */}
      <div className={Styles.centerCard}>
        <div className={Styles.centerCardBox1}>
            <div className={Styles.context}>
              <div className={Styles.lefttem}>
                  <div className={Styles.leftItem1}>
                    欧皇徽章权益领取
                  </div>
              </div>
              <div className={Styles.rightItem}>
                  {!data?.hasBadgeFlag && <div className={Styles.leftItem2} style={{ filter: data?.badgeFlag ? '' : 'grayscale(1)'}} onClick={()=>handleToOrder(1)}></div>}
                  {data?.hasBadgeFlag &&<div className={Styles.leftItem3} onClick={()=>handleToOrder2()}>查看详情{'>'}</div>}
              </div>
            </div>
        </div>

        <div className={Styles.centerCardBox3}>
            <div className={Styles.title}></div>
            <div className={Styles.detail}>每个藏品可领以下对应类型的冰箱贴！</div>
            <div className={Styles.magnet}>
              {[
                { img: require('@/assets/img/culturalExchange_mazu/fridgemagnet1@2x.png'), text: '财源广进' },
                { img: require('@/assets/img/culturalExchange_mazu/fridgemagnet2@2x.png'), text: '马上抱富' },
                { img: require('@/assets/img/culturalExchange_mazu/fridgemagnet3@2x.png'), text: '穷鬼勿扰' },
                { img: require('@/assets/img/culturalExchange_mazu/fridgemagnet4@2x.png'), text: '钞票来符' },
                { img: require('@/assets/img/culturalExchange_mazu/fridgemagnet5@2x.png'), text: '财华横溢' },
                { img: require('@/assets/img/culturalExchange_mazu/fridgemagnet6@2x.png'), text: '钱途无量' },
                { img: require('@/assets/img/culturalExchange_mazu/fridgemagnet7@2x.png'), text: '财源滚滚' },
                { img: require('@/assets/img/culturalExchange_mazu/fridgemagnet8@2x.png'), text: '恭喜发财' },
              ].map((item, index) => (
                <div key={index} className={Styles.magnetItem}>
                  <img src={item.img} alt={item.text} />
                  <div className={Styles.magnetText}>{item.text}</div>
                </div>
              ))}
            </div>
            <div className={Styles.footerText}>
              实物可在<span className={Styles.linkText} onClick={toMyCollection}>我的藏品</span>中领取
            </div>
        </div>
        <div className={Styles.centerCardBox6}>
          {/* 标题区域 */}
          <div className={Styles.treasureHeader}>
            <div className={Styles.treasureTitle}>
              <img src={require('@/assets/img/culturalExchange_mazu/kbx@2x.png')} alt="开宝箱" />
            </div>
            <div className={Styles.treasureSubtitle}>开盲盒,达标领宝箱</div>
            <div className={Styles.scoreTableBtn} onClick={() => setShowScoreModal(true)}>
              <span>藏品分值表</span>
              <img src={require('@/assets/img/culturalExchange_mazu/question@2x.png')} alt="?" />
            </div>
          </div>

          {/* 当前分值 */}
          <div className={Styles.currentScore}>
            当前分值: {currentScore}
          </div>

          {/* 进度条 */}
          <div className={Styles.progressContainer}>
            <div className={Styles.progressBarWrapper}>
              <div className={Styles.progressBar}>
                <div 
                  className={Styles.progressFill}
                  style={{ width: `${calculateProgress()}%` }}
                ></div>
              </div>
              <div className={Styles.progressMarkers}>
                <div className={Styles.marker} style={{ left: '10.42%', transform: 'translateX(-50%)' }}>
                  <div 
                    className={Styles.markerTriangle}
                    style={{ 
                      borderTopColor: currentScore >= thresholds.level1 ? '#E50B18' : '#D8D8D8' 
                    }}
                  ></div>
                  <div className={Styles.markerText}>{thresholds.level1}</div>
                </div>
                <div className={Styles.marker} style={{ left: '50%', transform: 'translateX(-50%)' }}>
                  <div 
                    className={Styles.markerTriangle}
                    style={{ 
                      borderTopColor: currentScore >= thresholds.level2 ? '#E50B18' : '#D8D8D8' 
                    }}
                  ></div>
                  <div className={Styles.markerText}>{thresholds.level2}</div>
                </div>
                <div className={Styles.marker} style={{ left: '89.58%', transform: 'translateX(-50%)' }}>
                  <div 
                    className={Styles.markerTriangle}
                    style={{ 
                      borderTopColor: currentScore >= thresholds.level3 ? '#E50B18' : '#D8D8D8' 
                    }}
                  ></div>
                  <div className={Styles.markerText}>{thresholds.level3}</div>
                </div>
              </div>
              {/* 奖励层级 - 对齐到刻度下方 */}
              <div className={Styles.rewardsContainer}>
                {rewards.map((reward, index) => {
                  const buttonState = getButtonState(reward);
                  const positions = ['10.42%', '50%', '89.58%'];
                  const transforms = ['translateX(-50%)', 'translateX(-50%)', 'translateX(-50%)'];
                  return (
                    <div 
                      key={reward.id} 
                      className={Styles.rewardItem}
                      style={{ 
                        left: positions[index],
                        transform: transforms[index]
                      }}
                    >
                      <div className={Styles.rewardImage}>
                        <img src={reward.image} alt={reward.name} />
                      </div>
                      <div className={Styles.rewardName}>{reward.name}</div>
                      <div 
                        className={`${Styles.claimBtn} ${Styles[buttonState]}`}
                        onClick={() => handleClaimReward(reward.id)}
                      >
                        {buttonState === 'claimed' ? '已领取' : '领取'}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* 权益展示 */}
          {/* <div className={Styles.benefitsContainer}>
            {rewards.map((reward) => (
              <div key={`benefit-${reward.id}`} className={Styles.benefitItem}>
                <div className={Styles.benefitTitle}>{reward.name}权益:</div>
                <div className={Styles.benefitContent}>
                  <div className={Styles.benefitBox}>
                    <div className={Styles.benefitImage}></div>
                    <div className={Styles.benefitLabel}>实物</div>
                  </div>
                  <div className={Styles.benefitBox}>
                    <div className={Styles.benefitImage}></div>
                    <div className={Styles.benefitLabel}>优惠券</div>
                  </div>
                </div>
              </div>
            ))}
          </div> */}
        </div>

       

          <div className={Styles.footerBox}>
            <div className={Styles.footer}></div>
          </div>
      </div>

 {/* 领取成功弹窗 */}
 {showClaimSuccessModal && (
          <div className={Styles.modal}>
            <div className={Styles.modelShadow} onClick={() => setShowClaimSuccessModal(false)}></div>
            <div className={Styles.claimSuccessModal}>
              <div className={Styles.claimSuccessTitle}>
                <img src={require('@/assets/img/culturalExchange_mazu/ylq@2x.png')} alt="已领取" />
              </div>
              <div className={Styles.claimSuccessSubtitle}>请至我的藏品查看</div>
              <div className={Styles.claimSuccessImage}>
                {rewardImage && <img src={rewardImage} alt="" />}
              </div>
            </div>
          </div>
        )}

        {/* 藏品分值表弹窗 */}
        {showScoreModal && (
          <div className={Styles.modal}>
            <div className={Styles.modelShadow} onClick={() => setShowScoreModal(false)}></div>
            <div className={Styles.scoreModal}>
              <div className={Styles.closeBtn} onClick={() => setShowScoreModal(false)}>
                <img className={Styles.closeImg} src={require('@/assets/img/culturalExchange_mazu/Vector@2x.png')} alt="关闭" />
              </div>
              <div className={Styles.scoreModalTitle}>
                <img src={require('@/assets/img/culturalExchange_mazu/scoretitle@2x.png')} alt="藏品分值表" />
              </div>
              <div className={Styles.scoreGrid}>
                {[
                  { img: require('@/assets/img/culturalExchange_mazu/fridgemagnet7@2x.png'), score: '1200分' },
                  { img: require('@/assets/img/culturalExchange_mazu/fridgemagnet2@2x.png'), score: '600分' },
                  { img: require('@/assets/img/culturalExchange_mazu/fridgemagnet3@2x.png'), score: '480分' },
                  { img: require('@/assets/img/culturalExchange_mazu/fridgemagnet4@2x.png'), score: '400分' },
                  { img: require('@/assets/img/culturalExchange_mazu/fridgemagnet5@2x.png'), score: '300分' },
                  { img: require('@/assets/img/culturalExchange_mazu/fridgemagnet6@2x.png'), score: '200分' },
                  { img: require('@/assets/img/culturalExchange_mazu/fridgemagnet1@2x.png'), score: '150分' },
                  { img: require('@/assets/img/culturalExchange_mazu/fridgemagnet8@2x.png'), score: '100分' },
                ].map((item, index) => (
                  <div key={index} className={Styles.scoreGridItem}>
                    <div className={Styles.scoreImage}>
                      <img src={item.img} alt="" />
                    </div>
                    <div className={Styles.scoreText}>{item.score}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
    </div>
  )
}
export default Home
